import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49aff83e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-sm-12 col-md-6 col-lg-4 col-xl-4 p-0 mb-3 columns" }
const _hoisted_2 = { class: "card m-2 p-0 align-items-stretch rounded rounded-pill" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute top-0 start-50 translate-middle" }, null, -1))
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body p-0 m-0 mt-1" }, null, -1))
const _hoisted_7 = { class: "card-title p-0 m-3 mt-3 mb-5" }
const _hoisted_8 = { class: "list-group list-group-flush" }
const _hoisted_9 = { class: "list-group-item" }
const _hoisted_10 = { class: "list-group-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge rounded-pillms-1" }, "24h", -1))
const _hoisted_12 = { class: "list-group-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge rounded-pillms-1" }, "24h", -1))
const _hoisted_14 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge rounded-pillms-1" }, "24h", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge rounded-pill bg-white text-success ms-1" }, "dziennie", -1))
const _hoisted_17 = { class: "p-1 py-3 bg-white rounded-3 rounded-top rounded-pill" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import store from "@/store";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'koparkaWynik',
  props: {
  id: { type: Number, required: true },
  name: { type: String, required: true },
  link: { type: String, required: true },
  power: { type: Number, required: true },
  algorithm: { type: String, required: true },
  price: { type: Number, required: true },
  img: { type: String, required: true },
  hashrate: { type: Number, required: true },
  units: { type: String, required: true },
  revenue: { type: Number, required: true },
  profit: { type: Number, required: true },
  powerCost: { type: Number, required: true },
  daysToReachCost: { type: Number, required: true },
  heatProfit: { type: Number, required: true },
},
  setup(__props) {

const props = __props;

/* import { getAlgorithm } from "../tools/getAlgorithm"; */


const calculateDaysToReachCost = computed(() => {
  if (props.profit > 0) {
    return `Zwróci się w ${props.daysToReachCost} dni!`;
  } else {
    return `Nie zwróci się.`;
  }
});
const withHeat = computed(() => {
  return store.getters["miners/getMinersType"];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: _normalizeClass([{
          'bg-green': __props.daysToReachCost <= 365,
          'bg-lightGreen': __props.daysToReachCost > 365 && __props.daysToReachCost <= 730,
          'bg-yellow': __props.daysToReachCost > 730 && __props.daysToReachCost <= 1095,
          'bg-orange': __props.daysToReachCost > 1095 && __props.daysToReachCost <= 1460,
          'bg-red': __props.daysToReachCost > 1460,
        }, "rounded-bottom rounded-pill p-3 pt-3 pb-2"])
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(calculateDaysToReachCost.value), 1)
      ], 2),
      _createElementVNode("img", {
        src: __props.img,
        class: "card-img-top",
        alt: "..."
      }, null, 8, _hoisted_5),
      _hoisted_6,
      _createElementVNode("h5", _hoisted_7, _toDisplayString(__props.name), 1),
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", _hoisted_9, "Cena: " + _toDisplayString(__props.price) + " zł", 1),
        _createElementVNode("li", _hoisted_10, [
          _createTextVNode(" Wydobywa: " + _toDisplayString(__props.revenue) + " zł ", 1),
          _hoisted_11
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createTextVNode(" Zużywa prąd za: " + _toDisplayString(__props.powerCost) + " zł ", 1),
          _hoisted_13
        ]),
        (withHeat.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
              _createTextVNode(" Wytwarza ciepła za: " + _toDisplayString(__props.heatProfit) + " zł ", 1),
              _hoisted_15
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", {
          class: _normalizeClass([{
            'bg-green': __props.daysToReachCost <= 365,
            'bg-lightGreen': __props.daysToReachCost > 365 && __props.daysToReachCost <= 730,
            'bg-yellow': __props.daysToReachCost > 730 && __props.daysToReachCost <= 1095,
            'bg-orange': __props.daysToReachCost > 1095 && __props.daysToReachCost <= 1460,
            'bg-red': __props.daysToReachCost > 1460,
          }, "list-group-item p-3"])
        }, [
          _createTextVNode(_toDisplayString(__props.profit) + "zł ", 1),
          _hoisted_16
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("a", {
          href: __props.link,
          target: "_blank",
          class: "card-link h5"
        }, "Otwórz produkt w nowej karcie", 8, _hoisted_18),
        _hoisted_19
      ])
    ])
  ]))
}
}

})